import {
    getAdvanced,
    getBackgroundImages,
    getVerticalAlignment,
    getIsHidden,
    readInlineStyleValue
} from '../../utils'

const configAggregator = (node, props) => {
    // Determine which node holds the data for the appearance
    const dataNode =
        props.appearance === 'contained' ? node.firstElementChild || node : node
    const videoOverlayColor =
        props.appearance === 'full-width' || props.appearance === 'full-bleed'
            ? node.firstElementChild &&
              node.firstElementChild.getAttribute('data-video-overlay-color')
            : dataNode.firstElementChild &&
              dataNode.firstElementChild.getAttribute(
                  'data-video-overlay-color'
              )

    return {
        minHeight: readInlineStyleValue(dataNode.style.minHeight) ?? null,
        ...getVerticalAlignment(dataNode),
        backgroundColor: readInlineStyleValue(dataNode.style.backgroundColor),
        ...getBackgroundImages(dataNode),
        enableParallax: dataNode.getAttribute('data-enable-parallax') === '1',
        parallaxSpeed: parseFloat(dataNode.getAttribute('data-parallax-speed')),
        backgroundType: dataNode.getAttribute('data-background-type'),
        videoSrc: dataNode.getAttribute('data-video-src'),
        videoFallbackSrc: dataNode.getAttribute('data-video-fallback-src'),
        videoLoop: dataNode.getAttribute('data-video-loop') === 'true',
        videoPlayOnlyVisible:
            dataNode.getAttribute('data-video-play-only-visible') === 'true',
        videoLazyLoading:
            dataNode.getAttribute('data-video-lazy-load') === 'true',
        videoOverlayColor: videoOverlayColor || null,
        ...getAdvanced(dataNode),
        ...getIsHidden(node)
    }
}

export default configAggregator
